import React, { useContext } from 'react'
import { LocalesContext } from '../contexts/LocalesContext'
import { datetimeToPrettyString } from '../utils/data'

export default function SessionInfosComponent(props) {
  const { t } = useContext(LocalesContext)

  const { machine_name, device_mm_code, profile_name, client_name, field_name, duration_string, timestamp_creation, timestamp_end } = props.session  

  return (
    <table className="c-table">
      <tbody>
        <tr>
          <th>{t('Macchina')}</th>
          <td>{machine_name || device_mm_code}</td>
          <td className='mobile'>
            <span><p>{t('Macchina')}</p><p>{machine_name || device_mm_code}</p></span>
          </td>
        </tr>
        { props.user && (
        <tr>
          <th>{t('Utente')}</th>
          <td>{props.user}</td>
          <td className='mobile'>
            <span><p>{t('Utente')}</p><p>{props.user}</p></span>
          </td>
        </tr>
        )}
        { profile_name && (
        <tr>
          <th>{t('Profilo')}</th>
          <td>{profile_name}</td>
          <td className='mobile'>
            <span><p>{t('Profilo')}</p><p>{profile_name}</p></span>
          </td>
        </tr>
        )}
        { client_name && (
        <tr>
          <th>{t('Cliente')}</th>
          <td>{client_name}</td>
          <td className='mobile'>
            <span><p>{t('Cliente')}</p><p>{client_name}</p></span>
          </td>
        </tr>
        )}
        { field_name &&(
        <tr>
          <th>{t('Campo')}</th>
          <td>{field_name}</td>
          <td className='mobile'>
            <span><p>{t('Campo')}</p><p>{field_name}</p></span>
          </td>
        </tr>
        )}
        { duration_string && (
        <tr>
          <th>{t('Durata')}</th>
          <td>{duration_string}</td>
          <td className='mobile'>
            <span><p>{t('Durata')}</p><p>{duration_string}</p></span>
          </td>
        </tr>
        )}
        <tr>
          <th>{t('Inizio')}</th>
          <td>{datetimeToPrettyString(new Date(timestamp_creation))}</td>
          <td className='mobile'>
            <span><p>{t('Inizio')}</p><p>{datetimeToPrettyString(new Date(timestamp_creation))}</p></span>
          </td>
        </tr>
        <tr>
          <th>{t('Fine')}</th>
          { timestamp_end && (
            <td>{datetimeToPrettyString(new Date(timestamp_end))}</td>
          )}
          { timestamp_end && (
            <td className='mobile'>
              <span><p>{t('Fine')}</p><p>{datetimeToPrettyString(new Date(timestamp_end))}</p></span>
            </td>
          )}
          { !timestamp_end && (
            <td><span className="c-table__status c-table__status--working">{t('Working')}</span></td>
          )}
          { !timestamp_end && (
            <td className='mobile'>
              <span><p>{t('Fine')}</p><p><span className="c-table__status c-table__status--working">{t('Working')}</span></p></span>
            </td>
          )}
        </tr>
        { props.stats?.b1_area && (
        <tr>
          <th>{t('Total worked area')}</th>
          <td>{((props.stats.b1_area / 10000) * 100).toFixed(2)} ha</td>
          <td className='mobile'>
            <span><p>{t('Total worked area')}</p><p>{(props.stats.b1_area / 10000).toFixed(2)} ha</p></span>
          </td>
        </tr>
        )}
      </tbody>
    </table>
  )
}